<template>
  <div class="gardenProfitInfo">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws12" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="广告收入（元）" prop="advertProfit">
          <el-input v-model="ruleForm.advertProfit" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="车位收入（元）" prop="parkProfit">
          <el-input v-model="ruleForm.parkProfit" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="其他收入（元）" prop="otherProfit">
          <el-input v-model="ruleForm.otherProfit" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="支出费用（元）" prop="expense">
          <el-input v-model="ruleForm.expense" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="补贴物业服务费比例（%）" prop="subsidyScale">
          <el-input v-model="ruleForm.subsidyScale" placeholder="请输入" class="item-input" type="number">
          </el-input>
        </el-form-item>
        <el-form-item label="公示日期" prop="publicityDate">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="ruleForm.publicityDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同或协议" prop="contractFiles">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="contractFileListTemp" :clears="clears"
            @outputFile="getFile" @removeFile="removeFile"></upload-file>
        </el-form-item>
        <el-form-item label="费用支出证明" prop="expenseFiles">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="expenseFileListTemp" :clears="clears"
            @outputFile="getFile1" @removeFile="removeFile1"></upload-file>
        </el-form-item>
        <div class="jump-btn" style="text-align:center">
          <el-button class="detailbtn" type="primary" :disabled="isDisabled" @click="save('ruleForm')">
            保存
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:gardenProfitInfo
   *@Description:小区公共收益信息
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  import uploadmoreFiles from '../../../components/upload_morefile.vue'
  export default {
    data() {
      return {
        clears: false, // 清空按钮
        accept: '.jpg, .jpeg, .png',
        id: '', // id
        isDisabled: true, // 保存的可点击
        saveData: '',
        contractFileList: [], // 合同或协议文件
        contractFileListTemp: [], // 合同或协议文件
        expenseFileList: [], // 费用支出证明文件
        expenseFileListTemp: [], // 费用支出证明文件

        rules: {
          advertProfit: [{
            required: true,
            message: '请输入广告收入（元）',
            trigger: 'blur'
          }],
          parkProfit: [{
            required: true,
            message: '请输入车位收入（元）',
            trigger: 'blur'
          }],
          otherProfit: [{
            required: true,
            message: '请输入其他收入（元）',
            trigger: 'blur'
          }],
          expense: [{
            required: true,
            message: '请输入支出费用（元）',
            trigger: 'blur'
          }],
          publicityDate: [{
            required: true,
            message: '请选择公示日期',
            trigger: 'change'
          }],
        },
        ruleForm: {
          advertProfit: '', // 广告收入
          parkProfit: '', // 车位收入
          otherProfit: '', // 其他收入
          expense: '', // 支出费用
          subsidyScale: '', // 补贴物业服务费比例（%）
          publicityDate: '', // 公示日期
          contractFiles: [], // 合同或协议文件
          expenseFiles: [], // 费用支出证明文件
        },
      }
    },
    components: {
      'upload-file': uploadmoreFiles
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      getFile(e) {
        this.contractFileList.push({
          name: '',
          url: e
        })
        this.ruleForm.contractFiles = this.contractFileList
        console.log(this.contractFileList)
      },
      removeFile(e) {
        let list = []
        for (let i = 0; i < this.contractFileList.length; i++) {
          if (this.contractFileList[i] === e || (this.contractFileList[i].url && this.contractFileList[i].url === e)) {

          } else {
            list.push(this.contractFileList[i])
          }
        }
        this.contractFileList = list
        this.ruleForm.contractFiles = this.contractFileList
        this.contractFileListTemp = JSON.parse(JSON.stringify(list))
        console.log(this.contractFileList)
        console.log(this.ruleForm.contractFiles)
        console.log(this.contractFileListTemp)
      },
      getFile1(e) {
        this.expenseFileList.push({
          name: '',
          url: e
        })
        this.ruleForm.expenseFiles = this.expenseFileList
      },
      removeFile1(e) {
        let list = []
        for (let i = 0; i < this.expenseFileList.length; i++) {
          if (this.expenseFileList[i] === e || (this.expenseFileList[i].url && this.expenseFileList[i].url === e)) {

          } else {
            list.push(this.expenseFileList[i])
          }
        }
        this.expenseFileList = list
        this.ruleForm.expenseFiles = this.expenseFileList
        this.expenseFileListTemp = JSON.parse(JSON.stringify(list))
      },
      // 获取详情数据
      getData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawGardenIncome?gardenId=${this.gardenId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.list.length > 0) {
                this.ruleForm.advertProfit = res.list[0].advertProfit
                this.ruleForm.parkProfit = res.list[0].parkProfit
                this.ruleForm.otherProfit = res.list[0].otherProfit
                this.ruleForm.expense = res.list[0].expense
                this.ruleForm.subsidyScale = res.list[0].subsidyScale
                this.ruleForm.publicityDate = res.list[0].publicityDate
                let str = res.list[0].contractFiles
                let str1 = res.list[0].expenseFiles
                let arr = []
                let arr1 = []
                if (str) {
                  arr = str.split(',')
                }
                if (str1) {
                  arr1 = str1.split(',')
                }
                for (let i = 0; i < arr.length; i++) {
                  let obj = {}
                  obj.name = ''
                  obj.url = arr[i]
                  this.ruleForm.contractFiles.push(obj)
                }
                for (let i = 0; i < arr1.length; i++) {
                  let obj = {}
                  obj.name = ''
                  obj.url = arr1[i]
                  this.ruleForm.expenseFiles.push(obj)
                }
                this.contractFileList = this.ruleForm.contractFiles 
                this.expenseFileList = this.ruleForm.expenseFiles 
                this.contractFileListTemp = JSON.parse(JSON.stringify(this.ruleForm.contractFiles))
                this.expenseFileListTemp = JSON.parse(JSON.stringify(this.ruleForm.expenseFiles))
                this.id = res.list[0].id
                // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
                this.saveData = JSON.stringify(this.ruleForm)
                console.log(this.ruleForm)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        var arr = []
        var arr1 = []
        for (const key in params.contractFiles) {
          if (params.contractFiles[key].url) {
            arr.push(params.contractFiles[key].url)
          }
        }
        for (const key in params.expenseFiles) {
          if (params.expenseFiles[key].url) {
            arr1.push(params.expenseFiles[key].url)
          }
        }
        let strArr = arr.join(',')
        let strArr1 = arr1.join(',')
        params.contractFiles = strArr
        params.expenseFiles = strArr1
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              // 新增
              this.$post('/gardenDrawGardenIncome', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/gardenDrawGardenIncome/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
    },
  }
</script>

<style lang="scss">
  .gardenProfitInfo {

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>